import React from "react";
import Wrapper from "../../Components/Wrapper/wrapper";
import { Pageheader } from "../../Constants/pageheader";
import Student from "../../Components/student";

export const StudentAdmissionPage = () => {
  return (
    <Wrapper header={Pageheader.Students}>
      {/*   <StudentAdmissionForm /> */}
      <Student />
    </Wrapper>
  );
};
